import { useRef } from 'react';

import { Flex, Grid, Heading, Text } from '@chakra-ui/react';

import { StrapiImage } from '@/components/atoms';
import { AutoSlider } from '@/components/functional';
import { SectionContentWrapper, SectionWrapper } from '@/components/wrappers';
import { DynamicClientOpinionsFragment } from '@/graphql/generated';

import { Card } from './Card/Card';

export const DynamicClientOpinions = ({ title, subtitle, opinions }: DynamicClientOpinionsFragment) => {
  const containerRef = useRef(null);
  const splitPhrase = 'The results';

  let firstLine = title;
  let secondLine = '';

  if (title.startsWith(splitPhrase)) {
    firstLine = splitPhrase;
    secondLine = title.slice(splitPhrase.length).trim();
  }

  return (
    <SectionWrapper>
      <SectionContentWrapper color="purple.500" ref={containerRef} marginTop="70px">
        <Grid
          gridTemplateColumns={{
            base: '[column1-start column-start] minmax(0, 100%) [column1-end column2-start] 0 [column2-end column-end]',
          }}
          gridTemplateRows={{
            base: '[row1-start row-start] min-content [row1-end row2-start] min-content [row2-end row3-start] auto [row3-end row4-start] auto [row4-end row5-start] auto [row5-end row-end]',
          }}
        >
          <Heading
            /* GRID ITEM 1 */
            variant={{
              base: 'component-heading-large/xl',
              sm: 'component-heading-large/3xl',
            }}
            gridColumn="1 / span 2"
            gridRowEnd="row1-end"
            display="flex"
            flexDir="column"
          >
            <span>{firstLine}</span>
            <span>{secondLine}</span>
          </Heading>
          <Flex
            /* GRID ITEM 2 */
            gridColumnEnd="column1-end"
            gridRowStart="row2-start"
            gridRowEnd="row2-end"
            alignItems="center"
          >
            <Text
              variant={{
                base: 'text-md/lineHeight-6/font-semibold',
                sm: 'component-paragraph-headline/lg',
              }}
              height="fit-content"
              pt="20px"
            >
              {subtitle}
            </Text>
          </Flex>
          <Flex
            flexDir="column"
            alignItems="center"
            gridColumnStart={{ base: 'column1-start' }}
            gridColumnEnd={{ base: 'column1-end' }}
            gridRowStart={{ base: 'row3-start', xl: 'row1-start' }}
            gridRowEnd={{ base: 'row3-end', xl: 'row1-end' }}
            alignSelf="start"
            justifySelf={{ base: 'self-start', xl: 'self-end' }}
            mt={{ base: '20px', xl: '0' }}
          >
            {opinions.awardLogo?.data?.attributes && <StrapiImage image={opinions.awardLogo} />}
          </Flex>
        </Grid>
      </SectionContentWrapper>
      <AutoSlider>
        {opinions.opinions.map((card, index) => (card ? <Card card={card} key={`autoSlider_${index}`} /> : null))}
      </AutoSlider>
    </SectionWrapper>
  );
};
